/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PoseLandmark } from './poseLandmark';


export interface Poses {
    ea?: Array<PoseLandmark>;
    faceLandmarks?: Array<PoseLandmark>;
    leftHandLandmarks?: Array<PoseLandmark>;
    milestone?: boolean;
    poseLandmarks?: Array<PoseLandmark>;
    title?: string;
}

